import React from 'react';
import { Tooltip } from '@mui/material';

const toTitleCase = (str: string): string => {
  return str
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const ContextChips: React.FC<{ context: Record<string, any> }> = ({ context }) => {
  const chips: Array<{ key: string; label: string; tooltip: string }> = [];

  Object.entries(context).forEach(([key, value]) => {
    if (key === '_element_id_by_dimension_id') {
      // Split the value into individual entries and show element IDs
      Object.entries(value).forEach(([dimId, elemId]) => {
        chips.push({
          key: `${key}-${dimId}`,
          label: toTitleCase(String(elemId)),
          tooltip: `${toTitleCase(dimId)}: ${toTitleCase(String(elemId))}`
        });
      });
    } else {
      const dimensionName = key.split('@')[1] || key;
      if (typeof value === 'object') {
        // For object values, create a chip for each value
        Object.values(value).forEach((v, i) => {
          chips.push({
            key: `${key}-${i}`,
            label: toTitleCase(String(v)),
            tooltip: `${toTitleCase(dimensionName)}: ${toTitleCase(String(v))}`
          });
        });
      } else {
        chips.push({
          key,
          label: toTitleCase(String(value)),
          tooltip: `${toTitleCase(dimensionName)}: ${toTitleCase(String(value))}`
        });
      }
    }
  });

  return (
    <div className="context-chips">
      {chips.map(chip => (
        <Tooltip 
          key={chip.key} 
          title={chip.tooltip} 
          arrow
        >
          <div className="context-chip">
            {chip.label}
          </div>
        </Tooltip>
      ))}
    </div>
  );
}; 